import React from 'react'
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const DialogAntibiograms = (props) => {

    const {
        closeDialog, modalAntibiograms, antibiogramsSelectedTable

    } = props;
        
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    return (
        <Dialog
            header="Antibióticos"
            visible={modalAntibiograms}
            modal
            onHide={closeDialog}
            blockScroll
           className='small-dialog'
            
        >

            <DataTable 
                value={antibiogramsSelectedTable}
                 paginator
                rows={10}
                responsiveLayout="scroll"
                rowsPerPageOptions={[10, 50, 100]} 
                className="data-table p-datatable-striped p-datatable-sm"
            >
                <Column 
                    header="#"
                    body={(rowData, options) => options.rowIndex + 1}
                    headerStyle={headerStyle}
                    style={centerStyle}
                />

                <Column 
                    field="mic_antibiotic"
                    header="Antibióticos"
                    headerStyle={headerStyle}
                    style={cellStyle}
                />
            </DataTable>

    </Dialog>

    )
}
